import styled from 'styled-components/macro';
export const ButtonsGroupStyled = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;

  gap: ${({ getter }) => `${getter}px`};
`;
